import { Box } from '@mui/material';
import { Theme } from '@mui/material/styles';
import ExportToExcelIcon from '~/components/SVG/ExportToExcel.svg?react';

interface ExportToExcelProps {
  onClick?: () => void;
  isDisabled?: boolean;
}

const styles = {
  container: {
    display: 'flex',
    alignItems: 'end',
  },
  icon:
    (isDisabled = false) =>
    (theme: Theme) => ({
      width: '28px',
      height: '28px',
      cursor: isDisabled ? 'not-allowed' : 'pointer',
      color: theme.palette.grey.additionalGrey,
      opacity: isDisabled ? 0.7 : 1,
      '&:hover': {
        color: isDisabled ? theme.palette.grey.additionalGrey : theme.palette.primary.main,
      },
      [theme.breakpoints.down('sm')]: {
        width: '17px',
        height: '17px',
      },
    }),
};

const ExportToExcel = ({ onClick, isDisabled }: ExportToExcelProps) => {
  return (
    <Box title={isDisabled ? '' : 'Експорт в Excel'} sx={styles.container}>
      <Box component={ExportToExcelIcon} onClick={onClick} sx={styles.icon(isDisabled)} />
    </Box>
  );
};

export default ExportToExcel;
